var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Utils, Transformer } from '@pacem/pacem-core';
const DefaultFormLocalizationOptions = {
    display: (displayProp, prop, dictionary) => dictionary[`${displayProp}_${prop}`],
    validator: (validatorType, validatorTypeIndex, prop, dictionary) => dictionary['validator_' + validatorType + '_' + prop] ?? dictionary['validator_' + validatorType + validatorTypeIndex + '_' + prop],
    commandTooltip: (commandName, dictionary) => dictionary['command_tooltip_' + commandName]
};
export class Forms {
    /**
     * Localizes the metadata of a form **in place** using a translation dictionary.
     *
     * @param metadata The default metadata.
     * @param dictionary The translation dictionary.
     * @param options Custom replacement strategy, just in case.
     * @returns The localized metadata.
     */
    static localizeMetadata(metadata, dictionary, options) {
        return Forms._localizeMetadata(metadata, dictionary, options);
    }
    static _localizeMetadata(metadata, dictionary, options, prefix = '') {
        options = Utils.extend({}, DefaultFormLocalizationOptions, options);
        for (let prop of metadata.props) {
            // child form
            if ('props' in prop && typeof prop.props === 'object' && !Utils.isArray(prop.props)) {
                const pre = prefix + prop.prop + '.';
                prop.props = Forms._localizeMetadata(prop.props, dictionary, options, pre);
            }
            const display = prop.display = prop.display ?? {};
            const property = prefix + prop.prop;
            display.name = options.display('name', property, dictionary) ?? display.name;
            display.watermark = options.display('watermark', property, dictionary) ?? display.watermark;
            display.description = options.display('description', property, dictionary) ?? display.description;
            if (!Utils.isNullOrEmpty(prop.commands)) {
                for (let command of prop.commands) {
                    const tooltip = options.commandTooltip(command.name, dictionary);
                    if (!Utils.isNullOrEmpty(tooltip)) {
                        command.tooltip = tooltip;
                    }
                }
            }
            if (!Utils.isNullOrEmpty(prop.validators)) {
                const memoizer = {};
                for (let validator of prop.validators) {
                    const type = validator.type;
                    if (typeof type === 'string') {
                        const index = memoizer[type] = (memoizer[type] ?? -1) + 1;
                        const errorMessage = options.validator(type, index, property, dictionary);
                        if (!Utils.isNullOrEmpty(errorMessage)) {
                            validator['errorMessage'] = errorMessage;
                        }
                    }
                }
            }
        }
        return metadata;
    }
}
__decorate([
    Transformer('forms.localizeMetadata')
], Forms, "localizeMetadata", null);
//}
